export default __webpack_public_path__ + "static/image/image007.9eaeec37.jpg";